import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationTitle } from '../DeviationViews/_helpers';
import { ModalType } from '../Modals/redux/types';
import { pushModal } from '../Modals/redux/basicActions';

// ---- actionCreator pulled out to make redux Loadable
export const showDeviationGroupListPopup = (params: {
  deviationId: number;
  canRemoveFromGroup?: boolean;
  title?: string;
  url?: string;
}) => pushModal(ModalType.DEVIATION_GROUP_LIST, { params });

/** Returns an already dispatched action that pushes the DeviationGroupListPopup.
 *  Use this to open the modal */
export default function useDeviationGroupListPopup(deviation: PapiDeviation): () => void {
  const { deviationId } = deviation;
  const title = getDeviationTitle(deviation);
  const canRemoveFromGroup = deviation.extended?.canUserEdit;
  const url = deviation.extended?.groupListUrl;

  const dispatch = useDispatch();
  const dispatchedShowDeviationGroupListPopup = useCallback(() => {
    dispatch(
      showDeviationGroupListPopup({
        deviationId,
        canRemoveFromGroup,
        title,
        url,
      })
    );
  }, [dispatch, deviationId, canRemoveFromGroup, url, title]);
  return dispatchedShowDeviationGroupListPopup;
}
